import TemplateSwipe from "./TemplateSwipe.vue";
export default {
  components: {
    TemplateSwipe
  },
  props: {
    isMobile: Boolean,
    temp: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};